import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconDownload = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9.25C2.41421 9.25 2.75 9.58579 2.75 10V12.6667C2.75 12.8214 2.81146 12.9697 2.92085 13.0791C3.03025 13.1885 3.17862 13.25 3.33333 13.25H12.6667C12.8214 13.25 12.9697 13.1885 13.0791 13.0791C13.1885 12.9697 13.25 12.8214 13.25 12.6667V10C13.25 9.58579 13.5858 9.25 14 9.25C14.4142 9.25 14.75 9.58579 14.75 10V12.6667C14.75 13.2192 14.5305 13.7491 14.1398 14.1398C13.7491 14.5305 13.2192 14.75 12.6667 14.75H3.33333C2.7808 14.75 2.25089 14.5305 1.86019 14.1398C1.46949 13.7491 1.25 13.2192 1.25 12.6667V10C1.25 9.58579 1.58579 9.25 2 9.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.13569 6.13617C4.42858 5.84328 4.90345 5.84328 5.19635 6.13617L7.99935 8.93918L10.8024 6.13617C11.0952 5.84328 11.5701 5.84328 11.863 6.13617C12.1559 6.42907 12.1559 6.90394 11.863 7.19683L8.52968 10.5302C8.38903 10.6708 8.19826 10.7498 7.99935 10.7498C7.80044 10.7498 7.60967 10.6708 7.46902 10.5302L4.13569 7.19683C3.84279 6.90394 3.84279 6.42907 4.13569 6.13617Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V10C8.75 10.4142 8.41421 10.75 8 10.75C7.58579 10.75 7.25 10.4142 7.25 10V2C7.25 1.58579 7.58579 1.25 8 1.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);
